import { useState, useEffect } from 'react';
import { TextField, IconButton, Grid, Typography } from '@mui/material';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { isFunction } from 'lodash';
import NumberRangePicker from '../../Components/NumberRangePicker';

export default function ConditionItem({ initial, onChange, onDelete, fieldTitle }) {
  const [rowsToRequire, setRowsToRequire] = useState(10);
  const [rangeParams, setRangeParams] = useState(null);

  useEffect(() => {
    setRowsToRequire(initial?.rowsToRequire ?? 10);
    setRangeParams(initial ? { ...initial, rowsToRequire: undefined } : null);
  }, [initial]);

  function sendResult(data) {
    if (!isFunction(onChange)) return;

    const result = {
      ...rangeParams,
      rowsToRequire,
      ...data,
      column: undefined,
    };

    onChange(result);
  }

  return (
    <Grid container sx={{ py: 1 }} id={initial._id}>
      <Grid container alignItems="center" wrap="nowrap">
        <Grid item>
          <NumberRangePicker
            prefix={
              <>
                If <span style={{ fontWeight: 500 }}>{fieldTitle}</span> is
              </>
            }
            initial={rangeParams}
            onChange={(res) => {
              sendResult(res);
              setRangeParams(res);
            }}
          />
        </Grid>

        <IconButton sx={{ ml: 'auto' }} onClick={onDelete}>
          <DeleteOutlineRounded color="error" />
        </IconButton>
      </Grid>

      <Grid item container sx={{ mt: 1 }} alignItems={'baseline'} wrap="nowrap">
        <Typography>then require</Typography>
        <TextField
          type="number"
          onChange={(e) => {
            const value = e.target.value === '' ? '' : Number(e.target.value);
            if (value !== '' && value < 0) return;

            setRowsToRequire(value);
            sendResult({ rowsToRequire: value });
          }}
          value={rowsToRequire}
          sx={{ width: 80, mx: 1 }}
          variant="standard"
          required
        />
        <Typography>rows</Typography>
      </Grid>
    </Grid>
  );
}
